import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  House,
  Globe,
  ChatCircleText,
  CreditCard,
  Key,
  Palette,
  SignOut,
  List,
  X,
} from "@phosphor-icons/react";

const navItems = [
  { path: "/dashboard", label: "Overview", icon: House },
  { path: "/websites", label: "Websites", icon: Globe },
  { path: "/billing", label: "Billing", icon: CreditCard },
  { path: "/api-keys", label: "API Keys", icon: Key },
  { path: "/white-label", label: "White-Label", icon: Palette },
];

export default function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/auth");
  };

  return (
    <div className="min-h-screen bg-white flex">
      {/* Mobile Overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/20 z-40 lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-[#0A0A0A] text-white transform transition-transform duration-200 ${
          mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        {/* Logo */}
        <div className="p-6 border-b border-white/10">
          <div
            className="font-heading text-xl font-black tracking-tight cursor-pointer"
            onClick={() => navigate("/dashboard")}
          >
            Botyfi
          </div>
          <div className="text-xs text-white/40 mt-1 font-mono">PRO BUILDER</div>
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  setMobileOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                  isActive
                    ? "bg-white/10 text-white font-semibold"
                    : "text-white/60 hover:text-white hover:bg-white/5"
                }`}
              >
                <Icon size={18} weight={isActive ? "bold" : "regular"} />
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* Bottom Section */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/10">
          <div className="px-4 py-2 mb-3">
            <div className="text-xs text-white/40 uppercase tracking-wider">Signed in as</div>
            <div className="text-sm font-medium truncate">{user?.email}</div>
            <div className="text-xs text-[#002FA7] capitalize mt-0.5">
              {user?.plan || "Free"} Plan
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-white/60 hover:text-white hover:bg-white/5 transition-colors"
          >
            <SignOut size={18} />
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile Header */}
        <header className="lg:hidden flex items-center justify-between p-4 border-b border-[#E5E7EB]">
          <div className="font-heading text-lg font-black tracking-tight">Botyfi</div>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="p-2"
          >
            {mobileOpen ? <X size={24} /> : <List size={24} />}
          </button>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 lg:p-10 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
}
